import React from 'react';
import InteractiveEventMapClient from './components/InteractiveEventMapClient';

const InteractiveEventMapPage = () => {
  return <InteractiveEventMapClient />;
};

export default InteractiveEventMapPage;
